// material-ui
import { Typography } from '@mui/material';

// project imports
import NavGroup from './NavGroup';
import menuItem from '../../../../menu-items';
import { useAuth } from '../../../../contexts/AuthContext';
import { filterMenuItemsByPrivileges } from '../../../../auth/permissions';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
    const { privileges, currentUser } = useAuth();
    const visibleMenuItems = filterMenuItemsByPrivileges(menuItem, privileges, currentUser);
    const navItems = visibleMenuItems.items.map((item) => {
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return <>{navItems}</>;
};

export default MenuList;
